import { render, staticRenderFns } from "./DrawerNotification.vue?vue&type=template&id=aa28669e"
import script from "./DrawerNotification.vue?vue&type=script&lang=js"
export * from "./DrawerNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports